import * as React from "react";
import {Dialog, DialogActions, DialogContent, DialogTitle, Box} from "@mui/material";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import {toast} from "react-toastify";
import LoadingDialog from "../../components/loadingDialog";
import {campusZipsReplace, getCampusZips} from "./programSetService";

export default function ProgramSetZipsModal(params: {programSetId: number, campus: any, setCampus: any, reload: any}) {
    const [loading, setLoading] = React.useState(false);
    const [zips, setZips] = React.useState('');

    React.useEffect(() => {
        if (!params.campus) {
            setZips('');
            return;
        }

        setLoading(true);
        getCampusZips(params.programSetId, params.campus.name).then((list: string[]) => {
            setZips(list.join("\n"));
            setLoading(false);
        });
    }, [params.campus, params.programSetId]);

    const handleClose = (event?: any, reason?: any) => {
        if (reason && reason === "backdropClick")
            return;
        params.setCampus(null);
    };

    const handleSubmit = async () => {
        setLoading(true);
        const good = await campusZipsReplace(params.programSetId, params.campus.name, zips);

        if (good) {
            toast.success('Zips updated successfully');
            setLoading(false);
            handleClose();
            params.reload();
        } else {
            setLoading(false);
        }
    }

    if (!params.campus) return <> </>;

    const zipCount = zips.split("\n").filter((z) => !!z.trim()).length;

    return (
        <Dialog
            open={!!params.campus}
            onClose={handleClose}
            maxWidth={'sm'}
            fullWidth={true}
        >
            <DialogTitle>
                Zips - {params.campus.name}
            </DialogTitle>
            <DialogContent>
                <Box sx={{margin: '5px 0 10px 0', fontSize: '13px'}}>
                    One zip per line. Saving with no zips takes the campus offline.
                </Box>
                <TextField
                    autoComplete={'off'}
                    margin="dense"
                    id="zips"
                    label={`Zips (${zipCount.toLocaleString()})`}
                    type="text"
                    fullWidth
                    multiline
                    minRows={12}
                    maxRows={20}
                    size={'small'}
                    value={zips}
                    onChange={(e) => setZips(e.target.value)}
                />
            </DialogContent>
            {loading ? <LoadingDialog/> :
                <DialogActions>
                    <Button sx={{color: 'red'}} onClick={handleClose}>Close</Button>
                    <Button sx={{color: 'green'}} onClick={handleSubmit} autoFocus>Update</Button>
                </DialogActions>
            }
        </Dialog>
    )
}
